import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterChipItem } from 'src/app/shared/models/filter-chip-item';

@Component({
    selector: 'rms-filter-chip-list',
    templateUrl: './filter-chip-list.component.html',
    styleUrls: ['./filter-chip-list.component.scss'],
    standalone: false
})
export class FilterChipListComponent implements OnInit {

  @Input() items: Array<FilterChipItem> = [];
  @Output() onDeleteOption: EventEmitter<FilterChipItem> = new EventEmitter<FilterChipItem>();

  constructor() { }

  ngOnInit() {
  }

  public onDeleteOptionHandler(item: FilterChipItem): void {
    this.onDeleteOption.emit(item);
  }

}
